// 현장 상세 머리줄의 주 버튼은 하나 — 착공 전엔 착공, 기록할 수 있으면 오늘 기록, 닫힌 현장은 시공사례 초안. 준공·닫기는 보조 버튼이다.
import type { ContractStatus } from "../contract/types";
import { canStart } from "./transitions";
import { FINISHED_PROJECT_STATUSES, type Project, type ProjectStatus } from "./types";

export type ProjectPrimaryAction = "start" | "record" | "portfolio" | null;

export const projectPrimaryActionOf = (flags: {
  canStart: boolean;
  canRecord: boolean;
  closed: boolean;
}): ProjectPrimaryAction =>
  flags.canStart ? "start" : flags.canRecord ? "record" : flags.closed ? "portfolio" : null;

// 목록 줄의 「현장 착공」 — 상세와 같은 canStart(계약 체결)에 착공일 도래까지 본다(계약 상태를 모르면 띄우지 않는다).
export const listStartDue = (
  project: Pick<Project, "status" | "planned_start_date">,
  contractStatus: ContractStatus | undefined,
  today: string
): boolean =>
  contractStatus !== undefined &&
  canStart(project, contractStatus) &&
  project.planned_start_date !== null &&
  project.planned_start_date <= today;

// 준공(유지보수·완료) 현장은 같은 고객의 다음 공사로 — 기존 견적 작성 흐름(startQuote)에 고객만 넘긴다.
export const REPEAT_QUOTE_LABEL = "같은 고객으로 새 견적";
export const showsRepeatQuote = (status: ProjectStatus): boolean =>
  (FINISHED_PROJECT_STATUSES as readonly ProjectStatus[]).includes(status);
